const customerStatus = [
    {
        id: 1,
        heading: 'No Sales',
        value: '50'
    },
    {
        id: 2,
        heading: 'Sales',
        value: '70'
    },
    {
        id: 3,
        heading: 'Returning Customers',
        value: '60'
    }
];

export default customerStatus;